import { createStore } from "vuex";
import book from "./modules/book";
import common from "./modules/common";
import line from "./modules/line";
import member from "./modules/member";

export default createStore({
  modules: {
    book,
    common,
    line,
    member,
  },
});
